import { render, staticRenderFns } from "./editUnionSaleOrders_v2.vue?vue&type=template&id=5ed5f84c&scoped=true&"
import script from "./editUnionSaleOrders_v2.vue?vue&type=script&lang=js&"
export * from "./editUnionSaleOrders_v2.vue?vue&type=script&lang=js&"
import style0 from "./editUnionSaleOrders_v2.vue?vue&type=style&index=0&id=5ed5f84c&lang=less&scoped=true&"
import style1 from "./editUnionSaleOrders_v2.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed5f84c",
  null
  
)

component.options.__file = "editUnionSaleOrders_v2.vue"
export default component.exports